<template>
  <el-popover
    ref="popper"
    :key="`component-select-pop-${randomId}`"
    v-model="showList"
    v-bind="$attrs"
    :popper-class="`component-select-pop ${popperClass}`"
    placement="bottom-start"
    trigger="manual"
    @after-leave="handleAfterLeave"
    @show="onShow"
  >
    <!-- 显示的文本框 -->
    <div
      slot="reference"
      :key="`reference-${randomId}`"
      :style="{ width: componentWidth + 'px' }"
      :title="selectedLabel"
      :class="{
        'component-select-label': true,
        'component-select-label-disable': disabled,
        'is-selected': showList,
      }"
      @click="showFilterList($event)"
    >
      {{ selectedLabel }}
      <div :class="selectedLabel ? '' : 'component-select-label-default'">
        {{ selectedLabel || placeholder }}
      </div>
      <div class="select-arrow-wrapper">
        <i :class="arrowClasses" />
      </div>
    </div>

    <!-- 搜索框 -->
    <div v-if="localSearchEnable" class="local-search">
      <input
        v-model="searchKeyWorkds"
        :style="{ minWidth: componentWidth + 'px' }"
        :maxlength="20"
        :placeholder="searchOptions.placeholder"
        class="el-input__inner"
        type="text"
      />
      <i v-show="searchKeyWorkds" class="el-icon-close" @click="clearSearch" />
    </div>

    <!-- 全选按钮 -->
    <div
      v-if="needCheckAll && !searchKeyWorkds && multiple"
      class="select-item"
      @click="selectAll"
    >
      <span :class="getCheckStateClass" class="el-checkbox__input">
        <span class="el-checkbox__inner" />
      </span>

      <label class="select-item-label">{{ checkedAllLabel }}</label>
    </div>

    <!-- 下拉列表 -->
    <div
      :style="{ minWidth: componentWidth + 'px' }"
      class="select-list-container"
    >
      <div
        v-if="edit"
        class="select-item"
        @click.stop="menuClick('add')"
      >
        <label
          class="select-item-label"
        >
          <span class="btn add">+添加新联系信息</span>
        </label>
      </div>
      
      <div v-for="(item, index) in dataList" :key="index" class="list-item">
        <div
          v-if="edit && item.value !== null"
          :class="{
            'is-disabled': item.disabled,
            'is-none': item.show === false,
          }"
          class="select-item"
          @click.stop="selectItem(item)"
       
        >
          <label
            class="select-item-label"
            :title="item.label"
            :class="item.class"
            style="padding-right:100px"
          >
            {{ item.label }}
              <span class="menu" v-if="!item.disabled && item.show !== false">
                <span class="btn del" @click.stop="menuClick('del', item)"
                  >删除</span
                >
                <span class="btn edit" @click.stop="menuClick('edit', item)"
                  >编辑</span
                >
              </span>
          </label>
        </div>

        <div
          v-if="!edit"
          :class="{
            'item-checked': item.checked && !multiple,
            'is-disabled': item.disabled,
          }"
          class="select-item"
          @click.stop="selectItem(item)"
        >
          <span
            v-if="multiple"
            :class="{
              'el-checkbox__input': true,
              'is-checked': item.checked,
              'is-disabled': item.disabled,
            }"
          >
            <span class="el-checkbox__inner" />
          </span>
          <label
            class="select-item-label"
            :title="item.label"
            :class="item.class"
            >{{ item.label }}
          </label>
        </div>
      </div>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: "SelectCustom",

  inheritAttrs: false,

  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },

    /** 是否禁用 */
    disabled: {
      type: Boolean,
      default: false,
    },

    options: {
      type: Array,
      default() {
        return [];
      },
    },

    popperClass: {
      type: String,
      default: "",
    },

    /** 最大可选数 */
    maxSelect: {
      type: [Number],
      default: 100000,
    },

    /** 总宽度 */
    width: {
      type: [String, Number],
      default: "220",
    },

    /** 是否多选，默认true */
    multiple: {
      type: Boolean,
      default: true,
    },

    /** 是否需要全选按钮 */
    needCheckAll: {
      type: Boolean,
      default: true,
    },

    /** 默认的文字 */
    placeholder: {
      type: String,
      default: "请选择",
    },

    /** 全选状态下，显示的文字，如果文字判定为Flase，则显示所有选中的项的label */
    checkedAllLabel: {
      type: String,
      default: "全选",
    },

    /** 返回的结果的key */
    resultKey: {
      type: String,
      default: null,
    },

    /** 是否开启搜索功能 */
    searchEnable: {
      type: Boolean,
      default: false,
    },

    /**选项中是否显示请选择，只有在单选模式下， 该配置才起作用 */
    emptyEnable: {
      type: Boolean,
      default: true,
    },

    /**选项 - 请选择的默认值 */
    emptyValue: {
      type: null || undefined || Number || String,
      default: null,
    },

    change: {
      type: Function,
      default: null,
    },
    edit: {
      type: [Boolean, Function],
      default: false,
    },
  },

  data() {
    return {
      randomId: Math.random().toString().replace(".", ""),
      /** 当前显示的列表数据 */
      dataList: [],
      /** 原始的列表数据 */
      orinialList: [],
      /** 是否显示下拉列表 */
      showList: false,
      /** 是否全选了 */
      checkedAll: false,
      /** 是否半选 */
      indeterminate: false,
      /** 被选中的数据，只有在search.enable为true的情况下才启用 */
      selectedData: [],
      /** 搜索时的定时器 */
      searchTimer: null,
      /** 搜索的关键字 */
      searchKeyWorkds: "",

      localSearchEnable: this.searchEnable,

      /** 搜索的配置 */
      searchOptions: {
        placeholder: "请输入关键字", // 搜索输入框的提示文字
        interval: 50, // 搜索的间隔
        key: "label",
      },
    };
  },

  computed: {
    componentWidth() {
      return (this.width + "").replace(/px/, "");
    },

    arrowClasses() {
      return {
        "select-arrow": true,
        "el-icon-arrow-down": true,
        "select-arrow-reverse": this.showList,
      };
    },

    getCheckStateClass() {
      if (this.checkedAll) {
        return "is-checked";
      } else if (this.indeterminate) {
        return "is-indeterminate";
      } else {
        return "";
      }
    },
  },

  watch: {
    value(val) {
      if (!val || (this.options && !this.options.length)) return;

      this.handleData(this.dataList);
      this.setSelectedLabel();
    },

    options: {
      immediate: true,
      handler(val) {
        // this.searchKeyWorkds = "";
        if (val) {
          this.orinialList = JSON.parse(JSON.stringify(val));

          if (!this.multiple && this.emptyEnable) {
            this.generateEmpty(this.orinialList);
          }

          if (val.length > 10 && this.searchEnable) {
            this.localSearchEnable = true;
          } else {
            this.localSearchEnable = this.searchEnable;
          }

          this.handleData(val);
          this.setSelectedLabel();
        }
      },

      searchEnable(val) {
        this.localSearchEnable = val;
      },
    },

    searchKeyWorkds(val) {
      this.querySearch(val);
    },
  },

  mounted() {
    document.addEventListener("click", this.clickDoc);
  },

  beforeDestroyed() {
    document.removeEventListener("click", this.clickDoc);
  },

  methods: {
    menuClick(type, item) {
      if (typeof this.edit === "function") {
        this.edit(type, item);
      }
    },
    clearSearch() {
      this.searchKeyWorkds = "";
    },
    onShow() {
      this.searchKeyWorkds = "";
    },
    generateEmpty(data) {
      if (
        !data.find(
          (item) => item.value === this.emptyValue && item.label === "请选择"
        )
      ) {
        data.unshift({
          label: "请选择",
          value: this.emptyValue,
        });
      }
    },

    handleData(data) {
      let temp = JSON.parse(JSON.stringify(data));

      if (!this.multiple && this.emptyEnable) {
        this.generateEmpty(temp);
      }

      let checkedCount = 0;
      let checkedAll = true;

      this.dataList = temp.map((item) => {
        item.checked = this.value.includes(item.value);

        if (!item.checked) {
          checkedAll = false;
        } else {
          checkedCount++;
        }

        return item;
      });

      this.selectedData = this.dataList.filter((item) => item.checked);

      this.checkedAll = !!(checkedAll && checkedCount);
      this.indeterminate = !!(!checkedAll && checkedCount);
    },

    showFilterList(e) {
      if (this.disabled) return;

      this.showList = !this.showList;
    },

    reset() {
      if (this.localSearchEnable) {
        this.selectedData = [];
        this.searchKeyWorkds = "";
      }
      // 因为监听了搜索关键字，当搜索关键字改变时，会调用一次handleData，所以这里要判定
      else {
        this.handleData(this.orinialList);
      }

      this.setSelectedLabel();

      this.showList = false;
    },

    clickDoc(e) {
      if (!this.$el.contains(e.target)) {
        this.showList = false;
      }
    },

    setSelectedLabel() {
      let checkedItems = [];
      let checkedAll = true;
      let checkedCount = 0;

      if (this.localSearchEnable) {
        checkedItems = this.selectedData;
        checkedCount = this.selectedData.length;
        checkedAll = checkedCount === this.orinialList.length;
      } else {
        this.dataList.forEach((item) => {
          if (item.checked) {
            checkedItems.push(item);
            checkedCount++;
          } else {
            checkedAll = false;
          }
        });
      }

      if (this.multiple) {
        // 如果全部未选中
        if (!checkedCount) {
          this.selectedLabel = this.placeholder;
        } else {
          this.selectedLabel = checkedAll
            ? this.checkedAllLabel
            : checkedItems
                .reduce((prev, next) => {
                  prev += ";" + next.label;

                  return prev;
                }, "")
                .slice(1);
        }
      } else {
        this.selectedLabel = checkedItems.length ? checkedItems[0].label : null;
      }
    },

    /**
     * 搜索的时间控制
     * @param {String} value
     */
    querySearch(value) {
      this.debounce(() => {
        let datas = this.doSearch(value.trim());

        this.handleData(datas);

        this.$nextTick(() => {
          // 更新下拉框位置
          this.$refs.popper.updatePopper();
        });
      }, this.searchOptions.interval);
    },

    debounce(fn, wait = 100) {
      this.searchTimer && clearTimeout(this.searchTimer);

      this.searchTimer = setTimeout(fn, wait);
    },

    doSearch(value) {
      let temp = [];

      if (value === "") {
        temp = this.orinialList;
      } else {
        temp = this.orinialList.filter((item) => {
          return item[this.searchOptions.key].indexOf(value) >= 0;
        });
      }

      return temp;
    },

    /**
     * 点击列表时触发的事件
     */
    clickList(e) {
      e.stopPropagation();
    },

    /**
     * 选中某一项时触发的事件
     * @param {Object} item
     */
    selectItem(item) {
      if (item.disabled) return;

      if (this.multiple) {
        item.checked = !item.checked;
      } else {
        let checkedItem = this.dataList.find((item) => item.checked);

        if (checkedItem && checkedItem.value === item.value) return;

        this.dataList.forEach((child) => {
          child.checked = item.value === child.value;
        });
      }

      let checkedAll = true;
      let checkedCount = 0;

      if (this.localSearchEnable) {
        // 如果该项是取消选中，则将该项从已选项中去除
        if (!item.checked) {
          this.selectedData.splice(
            this.selectedData.findIndex((child) => child.value === item.value),
            1
          );
        } else {
          if (!this.multiple) {
            this.selectedData = [{ ...item }];
          } else {
            this.selectedData.push(item);
          }
        }
      }
      // 如果不开启搜索，则计算全选的状态
      else {
        this.dataList.forEach((child) => {
          if (child.checked) {
            checkedCount++;
          } else {
            checkedAll = false;
          }
        });

        this.checkedAll = !!(checkedAll && checkedCount);
        this.indeterminate = !!(!checkedAll && checkedCount);
      }

      if (!this.multiple) {
        this.showList = false;
      }

      this.getValue();
      this.setSelectedLabel();
    },

    selectAll() {
      this.checkedAll = !this.checkedAll;
      this.indeterminate = false;

      this.dataList = this.dataList.map((item) => {
        item.checked = this.checkedAll;

        return item;
      });

      if (this.localSearchEnable) {
        this.selectedData = this.checkedAll ? [...this.dataList] : [];
      }

      this.getValue();
      this.setSelectedLabel();
    },

    handleAfterLeave() {
      let res = [];

      if (this.localSearchEnable) {
        res = [...this.selectedData];
      } else {
        res = this.dataList.filter((item) => item.checked);
      }

      this.$emit("after-leave", [...this.selectedData]);
    },

    /**
     * 获取结果数据
     */
    getValue() {
      let checkedItems = this.localSearchEnable
        ? this.selectedData
        : this.dataList.filter((item) => item.checked);

      let value = checkedItems.map((item) => item.value);

      this.$emit("input", value);
      this.$emit("change", checkedItems);

      if (typeof this.change === "function" && this.change) {
        this.change(checkedItems);
      }

      let parent = this.$parent || this.$root;
      let name = parent.$options.componentName;

      while (parent && (!name || name !== "ElFormItem")) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }

      if (parent) {
        parent.$emit.apply(parent, ["el.form.change"].concat([...value]));
      }
    },
  },
};
</script>

<style lang="scss">
.local-search {
  padding: 8px 10px;
  position: relative;
  .el-icon-close {
    position: absolute;
    right: 16px;
    top: 17px;
    cursor: pointer;
  }
}
.component-select {
  &-label {
    width: 160px;
    display: inline-block;
    padding: 0 25px 0 12px;
    border: 1px solid #d4d6df;
    height: 32px;
    line-height: 32px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 12px;
    cursor: pointer;
    position: relative;
    background-color: #fff;
    border-radius: 2px;
    color: #666;
    outline: none;

    &.is-selected {
      border-color: #8eace8 !important;
    }

    &-disable {
      background-color: #f5f7fa !important;
      color: #c0c4cc !important;
      cursor: not-allowed !important;
      opacity: 0.75 !important; // border-color: #ebeef5 !important;
    }

    .select-arrow-wrapper {
      width: 25px;
      position: absolute;
      right: 0;
      top: 0;
      height: inherit;
    }

    .select-arrow {
      position: absolute;
      top: 9px;
      right: 6px;
      font-size: 14px;
      color: #b1c1d6;
      font-weight: bold;
      transform: scale(0.8);
      transform-origin: center;
      transition: 0.2s;
    }

    .select-arrow-reverse {
      transform: rotate(180deg);
    }
  }

  &-pop {
    margin-top: 8px;
    padding: 5px 0;
    width: auto;

    .select-list-container {
      max-height: 280px;
      overflow: auto;

      .el-input {
        padding: 5px 10px;
      }
    }

    .select-item {
      padding: 8px 10px;
      max-width: 680px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      background-color: #fff;
      white-space: nowrap;
      cursor: pointer;
      font-size: 12px;
      &:hover {
        background-color: #e4e8f1;
      }

      &.item-checked {
        background-color: #403cf0 !important;
        color: #fff !important;
        .btn {
          color: #fff !important;
        }
      }

      &.is-disabled {
        background-color: #eee;
        color: #aaa;
        cursor: not-allowed;

        .select-item-label {
          cursor: not-allowed;
        }
      }
      &.is-none {
       display: none;
      }
    }

    .select-item-label {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      margin-left: 6px;
      font-size: 14px;
      cursor: pointer;
      position: relative;
      //  margin-right:60px;
      .add{
         color: #4061f8;
      }
      .menu {
        display: inline-block;
        // background-color:#fff;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        margin-left: 20px;
        .btn {
          color: #4061f8;
          display: inline-block;
          margin-right: 10px;
        }
      }
    }

    .el-input {
      width: calc(100% - 20px);
      margin: 0 10px;
    }

    .el-input__inner {
      height: 30px;
      padding: 0 10px;
    }

    input::-webkit-input-placeholder {
      color: #c0c4cc !important;
    }
  }
}
</style>
